"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _quarkCore = require("quark-core");

var _trigger = require("../trigger");

var _window = require("../../window");

var _BaseAlert = _interopRequireDefault(require("../BaseAlert"));

var _SuccessAlert = _interopRequireDefault(require("../SuccessAlert"));

var _WarningAlert = _interopRequireDefault(require("../WarningAlert"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// the map of alert types to components
var alertMap = {
  warning: _WarningAlert.default,
  success: _SuccessAlert.default
};

var AlertContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AlertContainer, _React$Component);

  function AlertContainer() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, AlertContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = AlertContainer.__proto__ || Object.getPrototypeOf(AlertContainer)).call.apply(_ref, [this].concat(args))), _this.state = {
      alerts: []
    }, _this._addAlert = function (alert) {
      // add it to the list
      _this.setState(function (_ref2) {
        var alerts = _ref2.alerts;
        return {
          alerts: _toConsumableArray(alerts).concat([alert])
        };
      });
    }, _this._removeAlert = function (alertId) {
      // add it to the list
      _this.setState(function (_ref3) {
        var alerts = _ref3.alerts;
        return {
          alerts: alerts.filter(function (_ref4) {
            var id = _ref4.id;
            return id !== alertId;
          })
        };
      });
    }, _temp));
  }

  _createClass(AlertContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(React.Fragment, null, this.state.alerts.length > 0 && React.createElement(_quarkCore.FlexColumn, {
        style: this.props.style
      }, React.createElement(_quarkCore.FlexColumn, {
        style: _styles.default.contentContainer
      }, this.state.alerts.slice(0, this.props.maxAlerts).map(function (alert) {
        // grab the appropriate kind of alert
        var AlertComponent = alertMap[alert.type] || _BaseAlert.default; // render the right alert

        return React.createElement(AlertComponent, _extends({
          key: alert.id
        }, alert, {
          onDismiss: function onDismiss() {
            return _this2._removeAlert(alert.id);
          }
        }));
      }))), React.createElement(_window.EventListener, {
        event: _trigger.QUARK_ALERT
      }, function (_ref5) {
        var alert = _ref5.detail;

        // if we received an alert that matches this containers namespace
        if (alert.namespace === _this2.props.namespace) {
          // add the alert
          _this2._addAlert(alert);
        }
      }));
    } // add an alert to the list

  }]);

  return AlertContainer;
}(React.Component);

AlertContainer.defaultProps = {
  namespace: 'default',
  maxAlerts: 5
};
var _default = AlertContainer;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/alerts/AlertContainer/index.js
// module id = ./node_modules/quark-web/components/alerts/AlertContainer/index.js
// module chunks = 0